module.exports = __webpack_public_path__ + "static/media/github.f29a2e6a.svg";